import styled from "styled-components";

export const Container = styled.div`
  background-color: #fff;
  padding: 2rem 1.5rem 0.2rem 1.5rem;
`;
